import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { RouterModule } from "@angular/router";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { AppComponent } from "./app.component";
import { AppRoutes } from "./app.routing";
import { AuthGuard } from "./guards/auth-guard.service";
import { AdminLayoutComponent } from "./layouts/admin-layout/admin-layout.component";
import { LoginModule } from "./login/login.module";
import { AuthService } from "./services/auth.service";
import { PageService } from "./services/page-service";
import { FixedPluginModule } from "./shared/fixedplugin/fixedplugin.module";
import { FooterModule } from "./shared/footer/footer.module";
import { NavbarModule } from "./shared/navbar/navbar.module";
import { AddHeaderInterceptor } from "./services/interceptor";
import { ColorPickerModule } from "ngx-color-picker";
import { LimitexceededMsgModalComponent } from './shared/limitexceeded-msg-modal/limitexceeded-msg-modal.component';
import { ModulesAuthGuardService } from "./guards/modules-auth-guard.service";
import { ModuleauthService } from "./services/moduleauth.service";
import { ModulechildAuthGuardService } from "./guards/modulechild-auth-guard.service";
import { ModuleschildAuthService } from "./services/moduleschild-auth.service";
import { ModernSidebarModule } from "./modern-sidebar/modern-sidebar.module";
import { FilterMenuComponent } from "./modals/filter-menu/filter-menu.component";
import { ListingSubCategoryComponent } from './modules/listing-sub-category/listing-sub-category.component';
import { SubCategoryComponent } from './modules/category/sub-category/sub-category.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { SupportCategoiesQuickActionComponent } from "./modals/support-categoies-quick-action/support-categoies-quick-action.component";
import { SupportAssignTiketQuickActionComponent } from "./modals/support-assign-tiket-quick-action/support-assign-tiket-quick-action.component";
import { SupportBulkUpdateStatusQuickActionComponent } from "./modals/support-bulk-update-status-quick-action/support-bulk-update-status-quick-action.component";
import { SupportExportTicketsQuickActionComponent } from "./modals/support-export-tickets-quick-action/support-export-tickets-quick-action.component";
import { SupportSettingsQuickActionComponent } from "./modals/support-settings-quick-action/support-settings-quick-action.component";
import { FpoConfirmationDialogComponent } from './shared/fpo-confirmation-dialog/fpo-confirmation-dialog.component';



@NgModule({
  declarations: [
    AppComponent,
    AdminLayoutComponent,
    LimitexceededMsgModalComponent,
    FilterMenuComponent,
    ListingSubCategoryComponent,
    SubCategoryComponent,
     SupportCategoiesQuickActionComponent,
    SupportAssignTiketQuickActionComponent,
    SupportBulkUpdateStatusQuickActionComponent,
    SupportExportTicketsQuickActionComponent,
    SupportSettingsQuickActionComponent,
    FpoConfirmationDialogComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(AppRoutes, {
      useHash: false,
      relativeLinkResolution: "legacy",
    }),
    ModernSidebarModule,
    HttpClientModule,
    NavbarModule,
    FormsModule,
    ReactiveFormsModule,
    FooterModule,
    FixedPluginModule,
    LoginModule,
    NgbModule,
    ColorPickerModule,
    NgxPaginationModule,
  ],
  providers: [
    PageService,
    AuthGuard,
    AuthService,
    ModulesAuthGuardService,
    ModuleauthService,
    ModulechildAuthGuardService,
    ModuleschildAuthService,
    Location,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AddHeaderInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
